<!--suppress JSUnresolvedVariable -->
<template>
   <div class="material-input-group">
      <div class="input-row">
         <div class="material-input-addon prepend">
            <slot name="prepend" />
         </div>
         <div class="field-wrapper">
            <input
               v-bind="$attrs"
               :id="`input-${uid}`"
               v-model="inputValue"
               class="input-element"
               :class="{empty: inputValue === ''}"
               :type="type"
               :style="style"
               autocomplete="off"
               v-on="listeners">
            <label
               :for="`input-${uid}`"
               class="material-label"
               v-text="label" />
         </div>
         <div class="material-input-addon append">
            <slot name="append" />
         </div>
      </div>
      <div
         class="error-message"
         v-text="errorMessage" />
   </div>
</template>

<script>
/* eslint-disable vue/require-prop-type-constructor */
let uid = 0;
export default {
   name: 'MaterialInput',
   props: {
      modelValue: {
         type: [String, Number],
         required: true,
      },
      type: {
         type: String,
         default: 'text',
      },
      mask: {
         type: String,
         default: null,
      },
      label: {
         type: String,
         required: true,
      },
      shortLabel: {
         type: String,
         default: null,
      },
      errorMessage: {
         type: String,
         default: null,
      },
      inputStyle: {
         type: Object,
         default: () => ({}),
      },
   },
   data() {
      uid++;
      return { uid };
   },
   computed: {
      inputValue: {
         get() { return this.modelValue; },
         set(val) { this.$emit('input', val); },
      },
      inputComponent() {
         return this.mask !== null ? 'input-mask' : 'input';
      },
      style() {
         return {
            ...{
               height: '50px',
            },
            ...this.inputStyle,
         };
      },
      listeners() {
         return {
            focusin: this.onFocus,
            focusout: this.onBlur,
         };
      },
   },
   methods: {
      onFocus() {
         this.$root.$emit('focused', this);
      },
      onBlur() {
         this.$root.$emit('blurred', this);
      },
   },
};
</script>

<style lang="scss" scoped>
@import "~/colors.scss";

$bg-color: #f4f4f4;
$fg-color: #868686;
$radius: .3em;
$base-font-size: 16px;
.material-input-group {
   font-size: $base-font-size;
   color: $fg-color;
   font-family: 'Lato', sans-serif;
   display: flex;
   height: 100%;

   &.debug {
      padding: 2em;
      background-color: #fff;
   }

   .input-row {
      display: flex;
      flex-flow: row nowrap;
      width: 100%;
      border: 1px solid rgba(189, 186, 183, 0.8);
      border-radius: $radius;
      background-color: $bg-color;
      background-clip: content-box;

      .material-input-addon {
         min-width: $radius;

         &.prepend > * {
            border-top-left-radius: $radius;
            border-bottom-left-radius: $radius;
         }

         &.append > * {
            border-top-right-radius: $radius;
            border-bottom-right-radius: $radius;
         }
      }

      .field-wrapper {
         position: relative;

         .input-element {
            height: 100%;
            width: 100%;
            padding: 22px .25em .2em;
            color: $ff-dark-blue;
            background-color: transparent;
            outline: none;
            border: none;

            &:focus + label, &:not(.empty) + label {
               top: .25em;
               left: .5em;
               font-size: 75%;
               text-transform: uppercase;
               transform: translateY(0);
            }
         }

         .material-label {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: .25em;
            font-size: 110%;
            font-weight: normal;
            cursor: text;
            transition: all .2s;
         }
      }
   }
}
</style>
